import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

// 実力テスト志望校別成績取得（力だめし/定着度）

export namespace ApiTaRe220 {
  // API Name
  export const name: string = 'ApiTaRe220'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/getAbilityTestTryFixation'

    export interface Request {
      query: {
        fiscalYear: number
        testMonth: number
        testCountPerMonth?: number
        grade: number
        courseId: string
      }
    }

    export interface Response {
      abilityTestReport: {
        scoreList: {
          subjectCode: string
          score: string
        }[]
        choiceSchoolScoreList: {
          choiceSchoolName: string
          averageList: {
            subjectCode: string
            averageScore: string
          }[] | null
        }[]
      }
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        abilityTestReport: {
          scoreList: [
            {
              subjectCode: '',
              score: '',
            },
          ],
          choiceSchoolScoreList: [
            {
              choiceSchoolName: '',
              averageList: [
                {
                  subjectCode: '',
                  averageScore: '',
                },
              ],
            },
          ],
        },
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
